// InputField.tsx — для использования с <Field component={...} />
import React, { FC } from 'react'
import { FieldProps } from 'formik'
import { Input, InputProps } from '@shared/ui/molecules'

type InputFieldProps = Omit<InputProps, 'value' | 'onChange' | 'onBlur' | 'error'> & FieldProps

const InputField: FC<InputFieldProps> = ({ field, form, ...props }) => {
  const meta = {
    touched: form.touched[field.name] as boolean,
    error: form.errors[field.name] as string,
  }

  return <Input {...field} {...props} error={meta.touched && meta.error ? meta.error : ''} />
}

export default InputField
